// eslint-disable-next-line no-shadow
export enum GenerateSource {
	HOME = 'home',
	CHANGE_IT = 'change_it',
	TRUE_TOUCH = 'true_touch',
	FACE_SWAP = 'face_swap',
	LIP_SYNC = 'lip_sync',
	LIP_SYNC_AUDIO = 'lip_sync_audio',
	LIP_SYNC_FREE = 'lip_sync_free',
	UPSCALE_8K = 'upscale',
	VIDEO_ANYONE = 'video_anyone',
}
